import React, { useEffect, useState, useCallback } from "react";

// react meta tags
import { ReactTitle } from 'react-meta-tags';

// react redux
import { connect } from "react-redux";

// custom hooks
import useQueryHook from "utlis/CustomHooks/useQueryHook";

// themes
import { Theme1 } from "./themes";

// react toastify
import { toast } from "react-toastify";

// redux actions
import { setGlobalLoading } from "redux/actions/actionCommon";
import { setCartDetails, setCartImages, setCartItem } from "redux/actions/actionCart";
import { setTempOrderId } from "redux/actions/actionAuth";

// API's
import { getCartItems, mergeCartItems } from "utlis/Apis/Cart_API";

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";

// helpers functions
import { saveToLocalStorage } from "utlis/helpers/Common/CommonHelperFunctions";


function Cart(props) {
    // props
    const {
        globalAppTheme,

        currentUser,
        commonToken,
        tempOrderId,
        setGlobalLoading,
        setCartDetails,
        setCartItem,
        setCartImages,
        setTempOrderId,
    } = props

    // consts
    const query = useQueryHook()
    const name_to_save_on_local_storage = `__toi_dd`

    // states
    const [tempOrderIdFromTheUrl, setTempOrderIdFromTheUrl] = useState("")

    // getting details from the url
    useEffect(() => {
        const tempOdId = query.get('temp_order_id')
        const sig = query.get('sig')

        if (tempOdId) {
            setTempOrderIdFromTheUrl(tempOdId) // setting the temp order id
        }
    }, [query])

    const validateDetailsFunc = useCallback(() => {
        if (tempOrderIdFromTheUrl) { // if temprory order id from the url exists

            if (currentUser === null) { // if there no user logged in currently
                console.log("USER IS NOT LOGGED IN");

                // global loading
                setGlobalLoading(true)

                // getting cart items from the database
                getCartItems(commonToken ?? "", tempOrderIdFromTheUrl).then(res => {
                    // global loading
                    setGlobalLoading(false)

                    const resData = res.data;

                    console.log("resData ", resData);

                    // if request succesfull
                    if (resData && resData.success) {
                        const cartData = resData.data;

                        // saving items to global store
                        setCartItem(cartData.content);
                        setCartImages(cartData.images);
                        setCartDetails({
                            cart_discount: cartData.cart_discount,
                            cart_items: cartData.cart_items,
                            cart_qty: cartData.cart_qty,
                            cart_sub_total: cartData.cart_sub_total,
                            cart_total: cartData.cart_total,
                            coupon_code: cartData.coupon_code,
                            coupon_value: cartData.coupon_value,
                            allCartData: cartData
                        });

                        // saving the token to the local storage and removing the old one if any
                        saveToLocalStorage(name_to_save_on_local_storage, tempOrderIdFromTheUrl)
                        // setting order id to the global store
                        setTempOrderId(tempOrderIdFromTheUrl)

                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.success("Cart update successfully", {
                            autoClose: 2000,
                        });
                    }

                    // if request is not succesfull
                    if (resData && resData.error) {
                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.error(resData?.message || "Unknown error occured", {
                            autoClose: 2500,
                        });
                    }
                }).catch((err) => {
                    console.log(`${ERROR_WHILE__NAME} getCartItems `, err.message);

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500,
                        onClose: () => {
                            // disabling global loading
                            setGlobalLoading(false)
                        },
                    });
                })

            } else { // if an user has already logged in
                console.log("USER IS LOGGED IN");

                // global loading
                setGlobalLoading(true)

                // merging cart items with the already selected cart items by user
                mergeCartItems(commonToken, {
                    customerId: currentUser.userId,
                    from: tempOrderId,
                    to: tempOrderIdFromTheUrl
                }).then(res => {
                    // global loading
                    setGlobalLoading(false)

                    const resData = res.data

                    // if request is success
                    if (resData.success) {
                        const accData = resData.data

                        // setting new temp order id
                        setTempOrderId(resData.temp_order_id)
                        saveToLocalStorage(name_to_save_on_local_storage, resData.temp_order_id)

                        // setting cart items details
                        setCartItem(accData.content);
                        setCartImages(accData.images);
                        setCartDetails({
                            cart_discount: accData.cart_discount,
                            cart_items: accData.cart_items,
                            cart_qty: accData.cart_qty,
                            cart_sub_total: accData.cart_sub_total,
                            cart_total: accData.cart_total,
                            coupon_code: accData.coupon_code,
                            coupon_value: accData.coupon_value,
                            allCartData: accData
                        });

                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.success("Cart update successfully", {
                            autoClose: 2000,
                        });
                    }

                    // if request has some errors
                    if (resData.error) {
                        console.log("Login error ", resData);

                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.error(resData.message || "Unknown error occured", {
                            autoClose: 2500
                        });
                    }
                }).catch((err) => {
                    console.log(`${ERROR_WHILE__NAME} mergeCartItems `, err.message);

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(UNKNOWN_ERROR_OCCURED, {
                        autoClose: 3000,
                        onClose: () => {
                            // global loading
                            setGlobalLoading(false)
                        },
                    });
                });
            }


            // const dataToValidate = {
            //     temp_order_id: tempOrderIdFromTheUrl,
            // }
            // validating user details
            // validateResetPassword(commonToken ?? "", dataToValidate).then(res => {
            //     const resData = res.data

            //     if (resData?.success) {  // if link is valid

            //     }

            //     if (resData?.error) {  // if link is inValid
            //         // global loading
            //         setGlobalLoading(false)

            //         // dismissing all the previous toasts first
            //         toast.dismiss();

            //         // showing the error message
            //         toast.info(resData?.message ?? "Unauthorized Access", {
            //             autoClose: 2500,
            //             onClose: () => { },
            //         });
            //     }
            // }).catch(err => {
            //     console.log("errr ", err);

            //     // global loading
            //     setGlobalLoading(false)
            // })
        }
    }, [
        currentUser,
        commonToken,
        tempOrderId,
        tempOrderIdFromTheUrl,
        setGlobalLoading,

        name_to_save_on_local_storage,
        setCartDetails,
        setCartImages,
        setCartItem,
        setTempOrderId
    ])


    // validating user request
    useEffect(() => {
        validateDetailsFunc()
    }, [validateDetailsFunc])

    return (
        <React.Fragment>
            {/* website title */}
            <ReactTitle title={"Cart | Ruhlistic Decor"} />

            {
                globalAppTheme === 'theme1' ? (
                    <Theme1 />
                ) : null
            }
        </React.Fragment>
    );
}

const getDataFromStore = (state) => {
    return {
        currentUser: state.auth.currentUser,
        commonToken: state.auth.commonToken,
        globalAppTheme: state.common.globalAppTheme,
        tempOrderId: state.common.tempOrderId,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),

        setCartDetails: cartDetails => dispatch(setCartDetails(cartDetails)),
        setCartItem: cartData => dispatch(setCartItem(cartData)),
        setCartImages: cartData => dispatch(setCartImages(cartData)),
        setTempOrderId: orderId => dispatch(setTempOrderId(orderId)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(Cart);